<template>
    <div>
        <navBox></navBox>
        <div class="banner" v-if="types == 'show'">
            <img :src="fullpathImg" alt="" />
        </div>
        <div class="banner" v-if="types == 'link'">
            <router-link :to="{ path: pathUrl }">
                <img :src="fullpathImg" alt="" />
            </router-link>
        </div>

        <subNav leadStyle="2px solid #283254"></subNav>
        <div class="leadership">
            <div class="wrap">
                <div class="title">Board of Directors</div>
                <div class="content" ref="content" id="content">
                        <div class="ManagementList" v-for="(item,index) in leadershipList" :key="index" :id="'person_' + item.id" :ref="'person_' + item.id">
                            <div class="caption" ><a href="javascript:void(0);"><div>{{item.name}}</div></a></div>
                            <div class="ceo">{{item.job.length>80?item.job.substring(0,80)+"...":item.job}}</div>
                            <div class="mgt_explain" v-html="item.explain"></div>
                        </div>
                </div>
            </div>
        </div>
        <div class="leaderBottom">
            <div class="title-container">
                <div class="title">Board Diversity Matrix for MultiMetaVerse Holdings Limited</div>
                <img src="@/assets/investor-Relation/pdf.png" alt="Download PDF" style="width: 22px;height:25px;margin-right:120px;margin-top: 18px" @click="downloadPdf" />
            </div>
            
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
export default {
    name: "leadership",
    components: { footerBox, navBox, subNav, mapBox },
    data(){
        return{
            leadershipList:[],
            types: "",
            fullpathImg:"",
            pathUrl:'',
        }
    },
    created(){
         this.$http.getIrDirectors().then(res=>{
            this.types =  res.config["Banner-banner-head"][0].types;
            this.fullpathImg=res.config["Banner-banner-head"][0].pic_fullpath;
            this.pathUrl=res.config["Banner-banner-head"][0].links;
            this.leadershipList=res.config["Business-member-management"]
        })
    },
    methods: {
        downloadPdf() {
            const pdfUrl = './doc/Board Diversity Matrix for MultiMetaVerse Holdings Limited 2023-12-13.pdf';
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = 'Board_Diversity_Matrix.pdf';
            link.click();
        }
    },
    mounted(){
    },
    watch:{
        leadershipList:function(){
            var url = window.location.href;
            var urlParam = url.split('#');
            var persionId = urlParam.pop();
            this.$nextTick(()=>{
                let target = this.$refs[persionId][0]
                target.scrollIntoView({
                    behavior: 'smooth'
                })
            })
        }
    }
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}

/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
//内容
.leadership {
    padding-bottom: 200px;
    .title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        padding: 70px 0 50px 0;
    }
    .content{
        // border: 1px solid #dcdcdc;
        padding: 25px 25px 60px 25px;
        .ManagementList {
            min-height: 200px;
            border-bottom: 1px #CCCCCC solid;
            .caption{
                font-size: 14px;
                color: #283254;
                font-weight: bold;
                border-bottom: 2px solid #aaacb6;
                display: inline-block;
                margin-bottom: 10px;
                height: 20px;
                font-family: 'Lucida Bright';
                padding-top: 20px;
            }
            .ceo{
                color: #333333;
                font-size: 14px;
                margin-bottom: 25px;
                height: 20px;
                font-family: 'Lucida Bright';
            }
            .mgt_explain{
                width: 90%;
                height: 100%;
                padding: 10px 0px 30px 10px;
                line-height: 24px;
                font-family: Lucida Bright;
            }
        }
    }
}

// 附件
.leaderBottom {
    padding-bottom: 240px;
    width: 1200px;
    height: 100px;
    margin: 0 auto;

    .title-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: -260px;
        img {
        cursor: pointer;

    }

    .title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        padding: 70px 0 50px 0;
    }
}

    
    
}



.clear {
    clear: both;
}
</style>